import { customerTestInstance } from '../axios';

const getCustomerList = (filters: any, pagination: any = { pageSize: 50, pageNumber: 1 }, sortOrder: any = {}) =>
  customerTestInstance.post('/customer/search/basic', { filters: {...filters, isProspect: false}, pagination, sortOrder });

export default getCustomerList;
